// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card[data-v-b4676788]{position:fixed;left:calc(50% - 175px);top:36px}.copy-field[data-v-b4676788]{max-height:150px;overflow:scroll}ul[data-v-b4676788]{padding-left:20px}", ""]);
// Exports
module.exports = exports;
